import { Dispatch } from "react";
import { connect } from "react-redux";
import { ProfileActions } from "../../core/actionTypes/profileDetailsActionTypes";
import { getProfileDetails } from "../../core/actionCreators/profileDetailsActionCreators";
import * as profileDetailsActions from "../../core/actionTypes/profileDetailsActionTypes";
import * as uploadDetailsAction from "../../core/actionTypes/uploadDocumentActionTypes";

import { AppState } from "../../core/reducers/rootReducer";
import Confirm from "./confirm";
import { getTransactionIdFromURL, isUserLoggedIn } from "../../constants/utils";
import { resumeJourney } from "../../core/actionCreators/uploadDocumentActionCreators";
import { UploadDocumentActions } from "../../core/actionTypes/uploadDocumentActionTypes";

const mapStateToProps = (state: AppState) => {
  let txnId = getTransactionIdFromURL();
  return {
    profileDetails: state.profileDetails,
    isAuthenticated: isUserLoggedIn(txnId),
    resumeJourneyResponse: state.upload.resumeJourneyResponse,
    isLoading: state.isLoading[profileDetailsActions.GET_PROFILE_DETAILS] || state.isLoading[uploadDetailsAction.RESUME_JOURNEY],
    partnerData: state.auth,
    transactionDetails: state.transactionDetails,
  };
};


const mapDispatchToProps = (dispatch: Dispatch<ProfileActions | UploadDocumentActions>) => ({
  getProfileDetails: () => {
    dispatch(getProfileDetails());
  },
  resumeJourney: () => {
    dispatch(resumeJourney())
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Confirm);
